import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import type { CultureImage } from '../types';

const CultureSection: React.FC = () => {
  const cultureImages: CultureImage[] = [
    {
      id: '1',
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80",
      alt: 'Team collaboration',
      caption: 'Relentless Collaboration'
    },
    {
      id: '2',
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80",
      alt: 'Success celebration',
      caption: 'Celebrating Wins'
    },
    {
      id: '3',
      image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80",
      alt: 'Workshop session',
      caption: 'Continuous Learning'
    },
    {
      id: '4',
      image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80",
      alt: 'Remote work setup',
      caption: 'Freedom & Flexibility'
    }
  ];

  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-bold text-text-primary mb-4">
              Life at Make Mind
            </h2>
            <p className="text-lg text-text-secondary">
              We work hard to build robots so we can enjoy being humans.
            </p>
          </div>
        </div>

        {/* Masonry-style Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {cultureImages.map((item, index) => (
            <div
              key={item.id}
              className={`group relative overflow-hidden rounded-2xl border border-border shadow-sm ${index === 0 ? 'md:col-span-2 md:row-span-2' : ''}`}
            >
              <div className={`w-full h-full bg-surface ${index === 0 ? 'min-h-[400px]' : 'min-h-[250px]'}`}>
                <Image
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
              
              <div className="absolute bottom-0 left-0 p-6">
                <p className="text-white font-bold text-lg tracking-wide transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  {item.caption}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Culture Stats */}
        <div className="grid md:grid-cols-3 gap-8 bg-surface rounded-2xl p-8 lg:p-12 border border-border">
          <div className="text-center space-y-2">
             <div className="w-12 h-12 mx-auto bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-4">
               <Icon name="Heart" size={24} />
             </div>
             <h3 className="font-bold text-text-primary">People First</h3>
             <p className="text-sm text-text-secondary">Mental health & burnout prevention are priority #1.</p>
          </div>
          <div className="text-center space-y-2">
             <div className="w-12 h-12 mx-auto bg-purple-100 rounded-full flex items-center justify-center text-purple-600 mb-4">
               <Icon name="Zap" size={24} />
             </div>
             <h3 className="font-bold text-text-primary">Fast Feedback</h3>
             <p className="text-sm text-text-secondary">We prefer "done" over "perfect". We ship, learn, and iterate.</p>
          </div>
          <div className="text-center space-y-2">
             <div className="w-12 h-12 mx-auto bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-4">
               <Icon name="Globe" size={24} />
             </div>
             <h3 className="font-bold text-text-primary">Remote Native</h3>
             <p className="text-sm text-text-secondary">Work from anywhere. We judge results, not hours.</p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CultureSection;